import React from 'react';
import './SupportSection.css';

interface SupportSectionProps {
  className?: string;
}

interface SupportOption {
  id: string;
  title: string;
  description: string;
  icon: string;
  href?: string;
  onClick?: () => void;
}

export const SupportSection: React.FC<SupportSectionProps> = ({ className }) => {
  const supportOptions: SupportOption[] = [
    {
      id: '1',
      title: 'Help Center',
      description: 'Find answers to common questions',
      icon: '❓',
      href: '/help'
    },
    {
      id: '2',
      title: 'Live Chat',
      description: 'Chat with our support team',
      icon: '💬',
      onClick: () => console.log('Opening live chat...')
    },
    {
      id: '3',
      title: 'Contact Us',
      description: 'Send us a message',
      icon: '📧',
      href: '/contact'
    },
    {
      id: '4',
      title: 'Documentation',
      description: 'API docs and guides',
      icon: '📚',
      href: '/docs'
    },
    {
      id: '5',
      title: 'Community',
      description: 'Join our community forum',
      icon: '👥',
      href: '/community'
    },
    {
      id: '6',
      title: 'Status Page',
      description: 'Check platform status',
      icon: '🟢',
      href: '/status'
    }
  ];

  const handleOptionClick = (option: SupportOption) => {
    if (option.onClick) {
      option.onClick();
    } else if (option.href) {
      // In a real app, this would navigate using router
      console.log(`Navigating to ${option.href}`);
    }
  };

  return (
    <section className={`support-section ${className || ''}`}>
      <div className="support-header">
        <h2 className="support-title">Support & Resources</h2>
        <p className="support-subtitle">Get help when you need it</p>
      </div>

      <div className="support-grid">
        {supportOptions.map((option) => (
          <div
            key={option.id}
            className="support-option"
            onClick={() => handleOptionClick(option)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleOptionClick(option);
              }
            }}
          >
            <div className="support-icon">
              {option.icon}
            </div>
            <div className="support-info">
              <h3 className="support-option-title">{option.title}</h3>
              <p className="support-option-description">{option.description}</p>
            </div>
            <div className="support-arrow">→</div>
          </div>
        ))}
      </div>

      <div className="support-footer">
        <div className="emergency-support">
          <h4 className="emergency-title">Need immediate help?</h4>
          <p className="emergency-description">
            For urgent account or trading issues, contact our emergency support line
          </p>
          <button className="emergency-btn">
            Emergency Support
          </button>
        </div>
      </div>
    </section>
  );
};
